import { UsersRound, ChartCandlestick, Gamepad2, Layers } from 'lucide-react'; // Pick icons you like
import { IconNode } from './IconNode';
import AirdropIcon from './AirDropIcon';

export const nodes = [
  {
    id: "platform",
    type: "iconNode",
    position: { x: 0, y: 0 },
    data: {
      label: "Platform",
      Icon: <Layers color='#3B82F6' size={32} />,
    },
  },
  {
    id: "airdrop",
    type: "iconNode",
    position: { x: 200, y: 200 },
    data: {
      label: "Airdrop",
      Icon: <AirdropIcon color='#3B82F6' width={38} height={38} />,
    },
  },
  {
    id: "players",
    type: "iconNode",
    position: { x: 0, y: 400 },
    data: {
      label: "Players",
      Icon: <UsersRound color='#3B82F6' size={32} />,
    },
  },
  {
    id: "game",
    type: "iconNode",
    position: { x: -200, y: 200 },
    data: {
      label: "Game",
      Icon: <Gamepad2 color='#3B82F6' size={32} />,
    },
  },
  {
    id: "dex",
    type: "iconNode",
    position: { x: 0, y: 170 },
    data: {
      label: "Dex",
      Icon: <ChartCandlestick color='#3B82F6' size={32} />,
    },
  },
];

export const nodeTypes = {
  iconNode: IconNode,
};